<div [formGroup]="formGroup">
  <sc-select-field labelDictionaryKey="tmc-yard.ui.admin.filter-administration.filter-conditions.current-station-type"
    [data]="options" formControlName="type"></sc-select-field>
</div>
